// Footer.js - Footer oscuro estilo federación
import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const COLUMNAS = [
  {
    titulo: 'Compite',
    links: [
      { to: '/events', label: 'Eventos' },
      { to: '/profile/postular-evento', label: 'Postular un evento' },
      { to: '/rules', label: 'Reglamentos' },
      { href: 'https://liftingcast.com/meets/mle6s8hzkh35/results', label: 'LiftingCast nacional' },
    ],
  },
  {
    titulo: 'Resultados',
    links: [
      { to: '/rankings', label: 'Rankings' },
      { to: '/records', label: 'Récords' },
      { to: '/clasificacion', label: 'Clasificación y DOTS' },
    ],
  },
  {
    titulo: 'ACHIPO',
    links: [
      { to: '/members', label: 'Miembros' },
      { to: '/associates', label: 'Clubes asociados' },
      { to: '/shop', label: 'Tienda' },
      {
        href: 'https://docs.google.com/forms/u/3/d/1x9dAmsaJ60_NPCqxDVs2D0XiY5mkJI_Ss-OXOOgIe0Y/edit?usp=drive_web',
        label: 'Denuncia, ética y disciplina',
      },
    ],
  },
];

const Footer = () => {
  return (
    <footer className="ach-footer">
      <div className="ach-footer-inner">
        <div className="ach-footer-grid">
          {COLUMNAS.map((col) => (
            <div key={col.titulo}>
              <h3 className="ach-display ach-footer-title">{col.titulo}</h3>
              <ul className="ach-footer-links">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.to ? (
                      <Link to={l.to}>{l.label}</Link>
                    ) : (
                      <a href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="ach-display ach-footer-title">Contacto</h3>
            <p className="ach-footer-contact">
              <a href="mailto:achipo.power@gmail.com">achipo.power@gmail.com</a>
              <br />
              Santiago, Chile
            </p>
            <div className="ach-footer-social">
              <a
                href="https://www.instagram.com/achipo_chile?igsh=MWd6dm1pZmxudWhiMw=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram ACHIPO"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="1" />
                </svg>
              </a>
              <a href="https://www.youtube.com/@achipo_chile" target="_blank" rel="noopener noreferrer" aria-label="YouTube ACHIPO">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <rect x="2" y="5" width="20" height="14" rx="4" />
                  <path d="M10 9l5 3-5 3z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="ach-footer-bottom">
          <div className="ach-footer-brand">
            <img src="/achipo.jpg" alt="" />
            <span>© {new Date().getFullYear()} ACHIPO · Agrupación Chilena de Powerlifting</span>
          </div>
          <div className="ach-footer-legal">
            <Link to="/privacy">Privacidad</Link>
            <Link to="/terms">Términos</Link>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
      </div>

      <style>{`
        .ach-footer {
          background-color: #0b0b0b;
          background-image: repeating-linear-gradient(135deg, rgba(255,255,255,.035) 0 2px, transparent 2px 22px);
          color: #fff;
          font-family: var(--achipo-font);
          padding: 72px clamp(16px, 8vw, 128px) 28px;
        }
        .ach-footer-inner { max-width: 1180px; margin: 0 auto; }
        .ach-footer-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
          gap: 40px;
        }
        .ach-footer-title { margin: 0 0 20px; font-size: 1.05rem; color: #fff; }
        .ach-footer-links { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px; }
        .ach-footer-links a {
          color: #e5e5e5; text-decoration: none;
          font-size: 0.85rem; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase;
        }
        .ach-footer-links a:hover, .ach-footer-contact a:hover { color: var(--achipo-red-bright); }
        .ach-footer-contact { margin: 0 0 18px; font-size: 0.9rem; line-height: 1.8; color: #c9c9c9; }
        .ach-footer-contact a { color: #fff; text-decoration: none; }
        .ach-footer-social { display: flex; gap: 8px; }
        .ach-footer-social a {
          width: 44px; height: 44px; border-radius: 50%;
          border: 1.5px solid #3a3a3a; color: #fff;
          display: inline-flex; align-items: center; justify-content: center;
          transition: border-color 0.2s, color 0.2s;
        }
        .ach-footer-social a:hover { border-color: var(--achipo-red-bright); color: var(--achipo-red-bright); }
        .ach-footer-bottom {
          margin-top: 56px; padding-top: 24px; border-top: 1px solid #262626;
          display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center; gap: 16px;
          font-size: 0.82rem; color: #a3a3a3;
        }
        .ach-footer-brand { display: flex; align-items: center; gap: 12px; }
        .ach-footer-brand img { width: 34px; height: 34px; border-radius: 50%; background: #fff; }
        .ach-footer-legal { display: flex; gap: 20px; }
        .ach-footer-legal a { color: #a3a3a3; text-decoration: none; }
        .ach-footer-legal a:hover { color: #fff; }
        @media (max-width: 640px) {
          .ach-footer { padding: 56px 16px 24px; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
